import React from 'react'
import remark from "remark";
import parse from "remark-parse";
import remarkToreact from 'remark-react';
import remarkAttr from 'remark-attr';
import { SocialIcon } from 'react-social-icons';
import { useFooter } from '../../../src/hooks/use-footer'
import TwitterLink from '../columns/social-media-links/TwitterLink';

function Footer() {
  const [node] = useFooter()
  const content = node.node.frontmatter.content

  return (
    <footer className="footer">
      <div className="content has-text-centered">
        {remark().use(parse).use(remarkAttr).use(remarkToreact).processSync(content).contents}
        <div><a href="https://tnyurl.ca/MCNewsSignup">Subscribe to our Newsletter</a></div>
        <div>Follow Us</div>
          <SocialIcon style={{margin: "2px", backgroundColor:"white", borderRadius:"5rem"}} url="https://www.facebook.com/profile.php?id=100057451509287" />
          <SocialIcon style={{margin: "2px", backgroundColor:"white", borderRadius:"5rem"}}  url="https://www.youtube.com/@MaintenanceCanada/" />
          <SocialIcon style={{margin: "2px", backgroundColor:"white", borderRadius:"5rem"}}  url="https://www.instagram.com/maintenance.connection.canada/" />
          <TwitterLink width={50} height={50} margin="2px" url="https://x.com/maintenancecon9?s=11&t" />
          <SocialIcon style={{margin: "2px", backgroundColor:"white", borderRadius:"5rem"}}  url="https://www.linkedin.com/company/maintenance-connection-canada03/" />
      </div>
    </footer>
  )
}

export default Footer
